import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { urlLocations } from "routes/urlLocations";
import Header from './Header/Header';

const BasicLayout = ({ children }) => {
    const navigate = useNavigate();
    
    useEffect(() => {
        const storage = localStorage?.getItem("storageTyp");
        const jwt = window[storage]?.getItem('jwt');

        !jwt && navigate(urlLocations.login);
    }, [navigate]);
    
    return (
        <>
            <Header />
            <div>{children}</div>
        </>
    )
};

export default BasicLayout;